import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';

interface UnassignedOrAssignedDocument {
  documentId: string | null;
  unassignedDocumentId: string | null;
}

interface MedicalRecordsUploadedDocumentsState {
  uploadingDocuments: UnassignedOrAssignedDocument[];
}

const initialState: MedicalRecordsUploadedDocumentsState = {
  uploadingDocuments: []
};

const medicalRecordsUploadedDocumentsSlice = createSlice({
  name: 'medicalRecordsUploadedDocuments',
  initialState: initialState,
  reducers: {
    setMedicalRecordsUploadingDocuments: (state, action: PayloadAction<UnassignedOrAssignedDocument[]>) => {
      state.uploadingDocuments = action.payload;
    }
  }
});

export const { setMedicalRecordsUploadingDocuments } = medicalRecordsUploadedDocumentsSlice.actions;

export const selectMedicalRecordsUploadingDocuments = (state: RootState) => {
  return state.medicalRecordsUploadedDocuments.uploadingDocuments;
};

export const medicalRecordsUploadedDocumentsReducer = medicalRecordsUploadedDocumentsSlice.reducer;
